<template>
  <div class="container">
    <div class="txt">{{ $t('heel').tips }}</div>
    <TabBar active="Heel" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TabBar from '@/components/tabBar'

export default {
  components: {
    TabBar,
  },
  data() {
    return {
      userInfo: {},
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'connection', 'baseMsg']),
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 20px 15px 60px 15px;
  background: var(--background_color);
  .txt{
    margin-top: 210px;
    text-align: center;
    font-size: 16px;
    color: var(--ntext_color);
  }
}
</style>
